import LogRocket from 'logrocket';
import { getTestModeConsole } from './testMode';

// Drop-in replacement for console.* across init/funnel code. Every call is always captured to
// LogRocket (visible in session replays for debugging customer issues); the customer's console
// only prints in dev builds or when ?test=true, so customers never see internal logs. The LogRocket
// message is built with a crash-proof stringify (React state / events / DOM nodes are circular and
// would throw a raw JSON.stringify), while the console still receives the original arguments so a
// developer sees real objects, not a flattened string.
const environmentName = process.env.REACT_APP_ENVIRONMENT;

const safeStringify = (value) => {
    if (typeof value === 'string') { return value; }
    try {
        return JSON.stringify(value);
    } catch (e) {
        try { return String(value); } catch (ex) { return '[unserializable]'; }
    }
};

const shouldWriteToConsole = () => getTestModeConsole() === true || environmentName !== 'PROD';

const emit = (severity, consoleMethod, args) => {
    try {
        LogRocket.captureMessage(args.map(safeStringify).join(' '), { extra: { severity, environment: environmentName } });
    } catch (e) {
        // never let logging break a flow
    }

    if (shouldWriteToConsole()) {
        try {
            consoleMethod(...args);
        } catch (e) {
            // never let logging break a flow
        }
    }
};

const trackingConsole = {
    log: (...args) => emit('Log', console.log, args),
    debug: (...args) => emit('Debug', console.debug, args),
    info: (...args) => emit('Info', console.info, args),
    warn: (...args) => emit('Warn', console.warn, args),
    error: (...args) => emit('Error', console.error, args)
};

export default trackingConsole;
